import _ from 'lodash';
import { lsFilters, lsI18nService } from 'ls-vue-common';
import { longGrassLengthCutoffInInches, getLongGrassPolicy } from 'ls-constants';

import { internationalizationMixin } from '@/mixins';
import { GRASS_HEIGHTS } from '@/constants';

const translate = (key, params) => {
  const i18n = new internationalizationMixin();
  return i18n.$options.methods.t(key, params);
};

const getLongGrassLabel = ({ scope, length, isSpecialGearNeeded = false }) => {
  let longGrassType = 'longGrass.longGrassDefault';
  let longGrassParams = {};

  switch (length) {
    case GRASS_HEIGHTS.BETWEEN_6_TO_12:
      longGrassType = 'longGrass.longGrassFee';
      longGrassParams = { from: 6, to: 12 };
      break;

    case GRASS_HEIGHTS.BETWEEN_13_TO_18:
      longGrassType = 'longGrass.longGrassQuote';
      longGrassParams = { from: 13, to: 18 };
      break;

    case GRASS_HEIGHTS.BETWEEN_19_TO_24:
      longGrassType = 'longGrass.longGrassQuote';
      longGrassParams = { from: 19, to: 24 };
      break;

    case GRASS_HEIGHTS.ABOVE_25:
      longGrassType = 'longGrass.longGrassQuoteAbove';
      longGrassParams = { above: 25 };
      break;
    case GRASS_HEIGHTS.BETWEEN_9_TO_15:
      longGrassType = 'longGrass.longGrassFee';
      longGrassParams = { from: 9, to: 15 };
      break;
    case GRASS_HEIGHTS.BETWEEN_16_TO_21:
      longGrassType = 'longGrass.longGrassQuote';
      longGrassParams = { from: 16, to: 21 };
      break;
    case GRASS_HEIGHTS.ABOVE_22:
      longGrassType = 'longGrass.longGrassQuoteAbove';
      longGrassParams = { above: 22 };
      break;
  }

  const specialGear = isSpecialGearNeeded ? `, ${translate('specialEquipment')}` : '';
  return translate(longGrassType, {
    ...longGrassParams,
    scope,
    specialGear,
  });
};

const getLongGrassQuoteFromEvent = ({ scheduleEvent }) => {
  return (
    _.get(scheduleEvent, 'long_grass_quote_service') ||
    _.get(scheduleEvent, 'long_grass_quote') ||
    {}
  );
};

const getMowingCycle = ({ cycle = 0 }) => {
  const mowingCycle = lsFilters.frequency({ cycle });
  return translate('mowingCycle', { cycle: mowingCycle });
};

const getLongGrassCutoffLengths = () => {
  return longGrassLengthCutoffInInches;
};

const isNewLongGrassLength = ({ grassLength }) => {
  return [
    GRASS_HEIGHTS.BETWEEN_9_TO_15,
    GRASS_HEIGHTS.BETWEEN_16_TO_21,
    GRASS_HEIGHTS.ABOVE_22,
  ].includes(grassLength);
};

const getGrassLengthOptions = () => {
  const { fee: min, quote: max } = longGrassLengthCutoffInInches;

  return [
    {
      label: lsI18nService.translate('grassHeight.under', { min }),
      value: 'under6',
    },
    {
      label: lsI18nService.translate('grassHeight.between', { min, max }),
      value: 'over6',
    },
    {
      label: lsI18nService.translate('grassHeight.over', { max }),
      value: 'over12',
    },
  ];
};

// eslint-disable-next-line import/prefer-default-export
export const lsLongGrassHelpers = {
  getLongGrassQuoteFromEvent,
  getLongGrassLabel,
  getMowingCycle,
  isNewLongGrassLength,
  getGrassLengthOptions,
  getLongGrassCutoffLengths,
  getLongGrassPolicy,
};
